import { API_LOCATION_URL } from 'infrastructure/config';
import { IGetInput, IGetResponse, IBuyerMatchListClient } from 'interfaceAdapter/gatewaySchemas/IBuyerMatchListClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');
const PATH = `${API_LOCATION_URL}/buyer/match_list`;

export class BuyerMatchListClient implements IBuyerMatchListClient {
    async get(input: IGetInput): Promise<IGetResponse> {
        const { token } = input;
        const method = 'GET';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-B': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        try {
            const response = await fetch(PATH, {
                method,
                headers,
            });

            const { data, message } = await response.json();

            return {
                data,
                message,
            };
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
